import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect } from "react";
import { getSites } from "../../api";
import type { SiteItem } from "../../types/site";

type SsSelectProps = {
  prefCode: string[] | null;
  divisionCode: string | null;
  changedValue: (value: number[]) => void;
};

export default function SsSelect({
  prefCode,
  divisionCode,
  changedValue,
}: SsSelectProps) {
  const [sites, setSites] = useState<SiteItem[]>([]);
  const [selectedValues, setSelectedValues] = useState<SiteItem[]>([]);

  const fetchSites = async () => {
    if ((Array.isArray(prefCode) && prefCode.length === 1) || divisionCode) {
      setSelectedValues([]);
      changedValue([]);
      try {
        const response = await getSites({
          pref: prefCode ? [Number(prefCode[0])] : undefined,
          division_code: divisionCode ? [divisionCode] : undefined,
          order: null,
          sort: null,
          page: 1,
          limit: null,
        });
        if (response.status !== "ok") {
          return;
        }
        const data = response.sites;
        if (data) {
          setSites(data);
        } else {
          console.error("ヒットするSSなし");
        }
      } catch (error) {
        console.error("API呼び出しエラー", error);
      }
    } else {
      setSites([]);
      setSelectedValues([]);
      changedValue([]);
    }
  };

  useEffect(() => {
    fetchSites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefCode, divisionCode]);

  return (
    <Autocomplete
      multiple
      limitTags={1}
      fullWidth
      size="small"
      options={sites}
      value={selectedValues}
      getOptionLabel={(site) => String(site.name ?? site.id)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField {...params} placeholder="複数選択可" rows={1} />
      )}
      onChange={(_event, newValues) => {
        setSelectedValues(newValues);
        changedValue(newValues.map((item) => item.id));
      }}
    />
  );
}
